import type { ICatalog, IMe } from '@platform/core/types';
import { alwaysIncluded } from './alwaysIncluded';
import { createdWorkspace } from './createdWorkspace';
import type { IOrderedSummary } from './IOrderedSummary';
import { pinnedKeys } from './pinnedKeys';

/**
 * Закріплені модулі Головної (прототип v4 pinnedTop: pinnedMods.length ? pinnedMods : основні модулі простору): закріплені, а без них —
 * установлені основні модулі в порядку простору (простір без CRM і бази знань: Справи, Завдання); у просторі, створеному користувачем, —
 * основні модулі, які прототип дає кожному новому простору (Справи, Завдання; база знань і CRM там лише вибрані). Чиста функція.
 */
export function homePinnedKeys(me: IMe | undefined, catalog: ICatalog | undefined, ws: string): string[] {
  const pinned = pinnedKeys(me, catalog, ws);
  if (pinned.length) return pinned;
  if (createdWorkspace(me, ws)) return alwaysIncluded(catalog);
  const order = (m: IOrderedSummary) => m.order ?? Number.MAX_SAFE_INTEGER;
  return (catalog?.modules ?? []).filter((m) => m.installed && m.core).sort((a, b) => order(a) - order(b)).map((m) => m.key);
}
